// extracted by mini-css-extract-plugin
export default {"card":"listCardCollapse_card__12UsS","collapse":"listCardCollapse_collapse__3YzBJ"};